import { Component } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import { LoginService } from '../../services/login.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-layout',
  imports: [
    MatSidenavModule,
    MatListModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  tpi = false;
  email = '';

  constructor(private loginService: LoginService, private router: Router, private route: ActivatedRoute) {
    this.loginService.getTpiStatus().subscribe(isTpi => {
      this.tpi = isTpi;
    });

    this.loginService.loginUserEmail.subscribe(email => {
      this.email = email;
    });
  }

  logout() {
    // logout logic using LoginService
    this.loginService.logout();
  }

  openNewTab(url: string) {
    window.open(url, '_blank');
  }
}
